import React, { useMemo } from "react";
import CcScoreBand from "./CcScoreBand";
import { cx } from "../utils";
import {
  getActiveScoreBandKey,
  mapScoreBreakdownToBands,
} from "./toolFormDisplay";

/**
 * CcToolFormScorePanel — live score header, breakdown bands, optional footer actions.
 */
const CcToolFormScorePanel = ({
  scoreBreakdown = [],
  currentScore = 0,
  category = "",
  footer,
  variant = "default",
  collapsible = false,
  defaultExpanded = false,
  className,
}) => {
  const bands = useMemo(
    () => mapScoreBreakdownToBands(scoreBreakdown),
    [scoreBreakdown],
  );

  const activeBand = useMemo(
    () => getActiveScoreBandKey(currentScore, bands),
    [currentScore, bands],
  );

  if (!bands.length) return null;

  return (
    <div
      className={cx(
        "cc-tool-form-score",
        variant === "compact" && "cc-tool-form-score--compact",
        className,
      )}
    >
      <CcScoreBand
        score={currentScore ?? 0}
        title={category || "—"}
        bands={bands}
        activeBand={activeBand}
        variant={variant}
        collapsible={collapsible || variant === "compact"}
        defaultExpanded={defaultExpanded}
      />
      {footer ? (
        <div className="cc-tool-form-score__footer">{footer}</div>
      ) : null}
    </div>
  );
};

export default CcToolFormScorePanel;
